<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>WORK FLOW<span class="head-btn-style">
                    <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                        <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" id="btn_WorkFlow_save" (click)="save($event)" class="save-btn-head"
                        [disabled]="saveDisabled" title="Save">
                        <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="Workflow" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="departmentColumns" [selectionField]="'WorkFlow_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addDepartment($event)" (editEntity)="editWorkflow($event)"
            (refreshEntities)="refreshDepartments($event)" (deleteEntity)="deleteDepartment($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearEntity()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-3 mb-2">
                    <textbox [caption]="'Name'" [formData]="entity" [maxlength]="200" [mandatory]="true"
                        id="txt_WorkFlow_name" [fieldName]="'WorkFlowName'" [(ngModel)]="entity.WorkFlowName"
                        ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-3 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        [fieldName]="'WorkFlowCode'" [(ngModel)]="entity.WorkFlowCode" ngDefaultControl
                        id="txt_WorkFlow_Prefix"></textbox>
                </div>
                <div class="col-md-3">
                    <dropdown [caption]="'Meeting Group'" [formData]="entity" [data]="meetingtypes"
                        [class]="'form-control'" [mandatory]="true" [filterable]="true"
                        (filterChanged)="getAllMeetingType($event)" [textField]="'MeetingTypeName'"
                        [valueField]="'MeetingType_Id'" [fieldName]="'MeetingType_Id'"
                        (selectionChanged)="getAllCommittee('')" [selectedItem]="selectedMeetingGroup"
                        [(ngModel)]="entity.MeetingType_Id" ngDefaultControl>
                    </dropdown>

                </div><!--[(ngModel)]="entity.meetingtypes"-->
                <div class="col-md-3 mb-2">
                    <label for="file">Meeting Type</label>
                    <kendo-multiselect [data]="committee" [filterable]="true" [textField]="'CommitteeName'" (filterChange)="getAllCommittee($event)"
                        [valueField]="'Committee_Id'" [placeholder]="'Select Meeting Type'" [class]="'form-control'"
                        [(ngModel)]="entity.MettingTypeCombo" ngDefaultControl></kendo-multiselect>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 mb-2">
                    <label for="file">Department<span style="color: red">*</span></label>
                    <kendo-multiselect [data]="_departments" [filterable]="true" [textField]="'DepartmentName'" (filterChange)="getAllDepartment($event)"
                        [valueField]="'Department_Id'" [placeholder]="'Select Department'" [class]="'form-control'"
                        [(ngModel)]="entity.departments" ngDefaultControl></kendo-multiselect>
                </div>
                <div class="col-md-3 mb-2">
                    <textbox [caption]="'Description'" [formData]="entity" [maxlength]="100" [mandatory]="false"
                        [multiline]="true" [fieldName]="'Description'" [(ngModel)]="entity.Description"
                        ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <dropdown [caption]="'Approver'" [formData]="entity" [data]="approvers" [class]="'form-control'"
                        [mandatory]="true" [filterable]="true" (filterChanged)="getAllApprovers($event)"
                        (selectionChanged)="setApproverEmployee($event)" [(ngModel)]="Workflowdetails.Emp_Ref_Id"
                        [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'" [fieldName]="'Emp_Ref_Id'" 
                        [selectedItem]="selectedEmployee" ngDefaultControl>
                    </dropdown>

                </div>
                <div class="col-md-3">
                    <div class="form-input">
                        <dropdown [caption]="'Approval Type'" [formData]="entity" [data]="basicmaster"
                            [class]="'form-control'" [mandatory]="true" [filterable]="true"
                            (filterChanged)="getAllApprovalType_type($event)"
                            [(ngModel)]="Workflowdetails.WorkFlowType_Id" [textField]="'DisplayText'"
                            [valueField]="'DisplayValue'" (selectionChanged)="getAllApprovalType_type('')"
                            [fieldName]="'DisplayText'" [selectedItem]="selectedbasic" ngDefaultControl>
                        </dropdown>
                    </div>
                </div>

                <div class="col-md-3">
                    <textbox [caption]="'Approval Order'" [mandatory]="true" [maxlength]="2" [formData]="entity"
                        [fieldName]="'OrderNo'" (keypress)="numberOnly($event)" [(ngModel)]="entity.WorkFlowOrder"
                        ngDefaultControl></textbox>
                </div>
                <!-- <div class="col-md-3">
                    <textbox [caption]="'Edit bit'" [mandatory]="true" [maxlength]="2" [formData]="entity"
                        [fieldName]="'bit'" (keypress)="numberOnly($event)" [(ngModel)]="entity.EditBit"
                        ngDefaultControl></textbox>
                </div> -->
                <div class="col-md-3">
                    <btn [label]="'Add'" title="Add" (click)="getval()" [class]="'btn-1 btn-11'"
                        [disabled]="saveDisabled" [type]="'button'"></btn>

                </div>
            </div>
            <div class="row">
                <div class="thr_form_2">
                    <div class="top-btns">
                        <grid [entities]="entity.WorkFlowDetailsarray"
                            [actionExclude]="['feedback','column','add','download','refresh']" [checkboxCol]="true"
                            [selectionField]="'Emp_Ref_Id'" showSelectAll="true" (editEntity)="edituser($event)"
                            (deleteEntity)="deleteuser($event)" [showActions]="true" [entityColumns]="WorkFlowColumns"
                            [pageSize]="10">
                        </grid>
                    </div>
                </div>
            </div>

            <div class="col-md-4 mb-2">
                <!-- <btn [label]="'Clear'" (click)="clearMember()" [class]="'btn-1 btn-11'"
                    [disabled]="saveDisabled" [type]="'button'"></btn> -->
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-1">
                <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                  title="Back Tab"></btn>
              </div>
            <div class="col-md-4 mb-2">
                <btn [label]="'Save'" id="btn_WorkFlow_save" (click)="save($event)" [class]="'btn-1 btn-11'"
                    [disabled]="saveDisabled" [type]="'button'"></btn>
            </div>
        </div> -->
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
</ng-template>

<kendo-dialog title="Work Flow Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="WorkFlowName" class="label label-1">Name : </label> {{details.WorkFlowName }}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="WorkFlowCode" class="label label-1">Code : </label> {{details.WorkFlowCode}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="MeetingTypeName" class="label label-1">Meeting Type Name : </label>
                {{details.MeetingTypeName}}
            </div>
        </div>
        <div class="row">

            <div class="col-md-4 br-table-data">
                <label for="Description" class="label label-1">Description : </label> {{details.Description}}
            </div>
        </div>
        <div class="row">
            <!-- <div class="col-md-4 mb-2">
            <label for="DepartmentName" class="label label-1">Department Name : </label> {{details.DepartmentName}}
          </div> -->
            <!-- <div class="col-md-4 mb-2">
            <label for="CommitteeName" class="label label-1">Meeting Type : </label>  {{details.CommitteeName}}
          </div> -->
        </div> <br><br>
        <div class="col-md-7 text-bold">
            {{ApproverCaption}}
        </div>
        <div>
            <grid [entities]="details.WorkFlowDetailsarray"
                [actionExclude]="['feedback','column','add','edit','delete','download','refresh']" [checkboxCol]="true"
                [entityColumns]="WorkFlowColumns"></grid>
        </div>
    </div>
</kendo-dialog>
<kendo-excelexport [data]="Workflow.data" [collapsible]="true" fileName="WorkFlow.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="WorkFlowName" title="Work Flow" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="WorkFlowCode" title="Code" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>